// extracted by mini-css-extract-plugin
export default {"component":"noteDialog__component___I8s6O","formComponent":"noteDialog__formComponent___4hLAG","textField":"noteDialog__textField___1XP32"};